/* import __COLOCATED_TEMPLATE__ from './div-overlay-layer.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { tracked } from '@glimmer/tracking';
import BaseLayer from 'ember-leaflet/components/base-layer';

/**
 * A base class for PopupLayer and TooltipLayer.
 *
 * @class DivOverlayLayer
 * @extends BaseLayer
 */
let DivOverlayLayer = (_class = class DivOverlayLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "destinationElementTag", 'div');
    _defineProperty(this, "destinationElement", document.createElement(this.destinationElementTag));
    _initializerDefineProperty(this, "shouldRender", _descriptor, this);
    _defineProperty(this, "leafletOptions", [...this.leafletOptions,
    /**
     * The offset of the popup position. Useful to control the anchor of the popup when
     * opening it on some overlays. Defaults to `Point(0, 7)`.
     *
     * @argument offset
     * @type {Point}
     */
    'offset',
    /**
     * A custom CSS class name to assign to the popup.
     *
     * @argument className
     * @type {String}
     */
    'className',
    /**
     * Map pane where the overlay layer will be added.
     *
     * @argument pane
     * @type {String}
     */
    'pane']);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "shouldRender", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { DivOverlayLayer as default };